import { createStore } from 'vuex';

import state from './state.json';

/** Loads in modules dynamically */
const requireContext = require.context('./modules', false, /.*\.js$/);

const modules = requireContext.keys()
  .map((file) => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
  .reduce((moduleFiles, [name, module]) => ({ ...moduleFiles, [name]: module }), {});

/** Exports the whole store */
export default createStore({
  state: {
    ...state,
    hasBanner: false,
  },
  modules,
  mutations: {
    SET_BANNER(state, hasBanner) {
      state.hasBanner = hasBanner;
    },
  },
});
